import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useTitle } from 'src/hooks/useTitle';

import CommerceNoticeListPage from './CommerceNoticeListPage';
import CommerceNoticeFormPage from './CommerceNoticeFormPage';
import CommerceNoticeDetailPage from './CommerceNoticeDetailPage';

const CommerceNoticePage: FC<{ title: string }> = ({ title }) => {
  useTitle(`GU 관리자 | ${title}`);
  return (
    <Routes>
      <Route path='/list' element={<CommerceNoticeListPage />} />
      <Route path='/create' element={<CommerceNoticeFormPage />} />
      <Route path='/edit/:id' element={<CommerceNoticeFormPage />} />
      <Route path='/detail/:id' element={<CommerceNoticeDetailPage />} />
      <Route path='/' element={<Navigate to='/commerce-notice/list' replace />} />
    </Routes>
  );
};

export default CommerceNoticePage;
